import CloneAssignmentView from "@features/assignments/CloneAssignment/view";

const CloneAssignment = () => {
  return <CloneAssignmentView />;
};

export default CloneAssignment;
